import { render, staticRenderFns } from "./FirstTab.vue?vue&type=template&id=53fe7e0c&scoped=true"
import script from "./FirstTab.vue?vue&type=script&lang=js"
export * from "./FirstTab.vue?vue&type=script&lang=js"
import style0 from "./FirstTab.vue?vue&type=style&index=0&id=53fe7e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe7e0c",
  null
  
)

export default component.exports